module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-bldg-small-e87f2e390147e87c98e6340f1291f3d5.png";